<template>
    <div :class="$root.edit ? 'editing' : ''">
        <v-card v-if="$root.edit && !$store.state.editMenu" width="100%" @click="setEditComponent" flat tile>
            <v-card-title class="headline zoezi-edit-color">
                <div class="d-flex align-center justify-center fill-width">
                    {{$translate('Page')}} {{$translate(name)}}
                </div>
            </v-card-title>
        </v-card>

        <component-wrapper
            ref="component"
            :config="config"
            :key="renderKey"
            :ripple="false"
        />
    </div>
</template>
<script>
import components from '../component.js'
export default {
    name: 'zoezi-page',

    zoezi: {
        title: 'Page',
        icon: 'mdi-book-open-variant',
        internal: true,
        type: 'sf'
    },
    props: {
        config: {
            title: 'Component',
            type: Object,
            fulltype: 'component',
            default: () => components.makeEmptyConfig({component: 'zoezi-rowlayout'})
        },
        name: {
            title: 'Page name',
            type: String
        },
        path: {
            title: 'Link',
            type: String,
            fulltype: 'path'
        }
    },
    data: () => ({
        renderKey: 0,
        showDrawer: true
    }),
    methods: {
        setEditComponent() {
            this.$store.commit('setEditComponent', this);
        },
        save() {
            this.$refs.component.save();
        }
    }
}
</script>
